import { Box, Button, Container, Typography } from "@mui/material";
import RoleTable from "../../features/role/components/RoleTable";
import { Add } from "@mui/icons-material";
import CustomModal from "../../shared/CustomModal";
import { useState } from "react";
import { InterfaceRoleEdit } from "../../features/role/data/role.interface";
import { useDispatch } from "react-redux";
import alertDelete from "../../shared/alert/alertDelete";
import { deleteRole, getRole } from "../../features/role/data/role.api";
import alertSuccess from "../../shared/alert/alertSuccess";
import RoleForm from "../../features/role/components/RoleForm";
import useAccess from "../../hooks/useAccess";

export default function RolePage() {

    const dispatch = useDispatch<any>()
    const access = useAccess()

    const [modalAdd, setModalAdd] = useState<boolean>(false)
    const [dataSelected, setDataSelected] = useState<InterfaceRoleEdit | undefined>(undefined)

    const handleDelete = (id: number) => {
        alertDelete()
            .then(async isConfirmed => {
                if (isConfirmed) {
                    try {
                        await dispatch(deleteRole(id))
                        await alertSuccess("Berhasil menghapus data")
                        await dispatch(getRole())
                    } catch (error) { }
                }
            })
    }

    return (
        <Container>
            <CustomModal
                open={modalAdd}
                title="Tambah Role"
                onClose={() => setModalAdd(false)}
                component={<RoleForm mode="ADD" onSubmit={() => setModalAdd(false)} />}
            />
            <CustomModal
                open={Boolean(dataSelected)}
                title="Edit Role"
                onClose={() => setDataSelected(undefined)}
                component={<RoleForm mode="EDIT" data={dataSelected} onSubmit={() => setDataSelected(undefined)} />}
            />
            <br />
            <Typography variant="h3">Role</Typography>
            {access("CREATE") && (
                <Box marginTop={1} display={"flex"} justifyContent={"flex-end"}>
                    <Button startIcon={<Add />} onClick={() => setModalAdd(true)}>Tambah</Button>
                </Box>
            )}
            <br />
            <RoleTable onEdit={access("EDIT") ? setDataSelected : undefined} onDelete={access("DELETE") ? handleDelete : undefined} />
        </Container>
    )
}